export const changeStartDay = (state, startDay) => {
  state.startDay = startDay;
};

export const changeEndDay = (state, endDay) => {
  state.endDay = endDay;
};

export const changeCountry = (state, country) => {
  state.country = country;
};

export const changeCountries = (state, countries) => {
  state.countries = countries;
};

export const changeTeam = (state, team) => {
  state.team = team;
};

export const changeTeamName = (state, teamName) => {
  state.teamName = teamName;
};

export const changeTeamSlug = (state, teamSlug) => {
  state.teamSlug = teamSlug;
};

export const changeSuperteam = (state, superteam) => {
  state.superteam = superteam;
};

export const changeSuperteamName = (state, superteamName) => {
  state.superteamName = superteamName;
};

export const changeSuperteamSlug = (state, superteamSlug) => {
  state.superteamSlug = superteamSlug;
};

export const changeUserId = (state, userId) => {
  state.userId = userId;
};

export const changeUserName = (state, userName) => {
  state.userName = userName;
};

export const changeSelection = (state, selection) => {
  state.selection = selection;
};

export const changeSnackbar = (state, snackbar) => {
  state.snackbar = { ...state.snackbar, ...snackbar };
};

export const changeTotalUsers = (state, users) => {
  state.totalUsers = users;
};

export const changeTotalCountries = (state, countries) => {
  state.totalCountries = countries;
};

export const changeStridesUsers = (state, users) => {
  state.stridesUsers = users;
};

export const changeStridesCountries = (state, countries) => {
  state.stridesCountries = countries;
};
